module.exports = __webpack_public_path__ + "static/media/casas-bahia.1ddabae7.svg";